import ReactModal from 'react-modal';
import { useModal } from 'react-modal-hook';

import HubspotCalendar from 'components/forms/schedule-demo/steps/hubspot-calendar';
import FontIcon from 'components/icons';

import './styles/downloads.scss';
import './styles/custom-calendar.scss';
import CloseBtn from '../buttons/button-close';

ReactModal.setAppElement('#___gatsby');

type ContentDownloadProps = {
    buttonArrow?: boolean,
    buttonModalLaunchText: string
    className?: string
    customCalendarUrl: string
}

const CustomCalendar = ({ 
  customCalendarUrl,
  buttonModalLaunchText,
  className,
  buttonArrow,
}:ContentDownloadProps) => {
  const [showModal, hideModal] = useModal(({ onExited }) => (
    <ReactModal
      isOpen
      onAfterClose={ onExited }
      onRequestClose={ hideModal }
      className="default-modal-wrapper custom-calendar-modal"
      overlayClassName="default-modal-overlay"
    >
      <section
        className="modal-inner-container"
        data-section="customCalendarModal"
      >
        <CloseBtn onClick={ hideModal } />
        <HubspotCalendar url={ customCalendarUrl } />
      </section>
    </ReactModal>
  ));
  // eslint-disable-next-line
  return (
    <button className={ `button is-rounded schedule-demo-button ${className && className} ` } type="button" onClick={ showModal }>
      {buttonModalLaunchText}
      {buttonArrow && <FontIcon icon="arrow-right" />}
    </button>
  );
};

export default CustomCalendar;
